import Calendar from '../../../../api/api-calendar';

export const fetchMonthsAvailability = (spaceId, dates, excludeBookingIds) => {
  const excludeBookingsQuery = Array.isArray(excludeBookingIds)
    ? excludeBookingIds
        .map((bkID, i) => {
          const queryExtension = `exclude_booking_ids=${bkID}`;
          return i === 0 ? `&${queryExtension}` : queryExtension;
        })
        .join('&')
    : '';

  const availabilityProms = (dates || []).map((date) => {
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    const monthQuery = `bookings/availability/space/${spaceId}/month?month=${month}&year=${year}${excludeBookingsQuery}`;

    return new Promise((resolve, reject) => {
      Calendar.readAnonymous(monthQuery, (response) => {
        if (response.error || response.statusCode >= 400) {
          reject(response);
          return;
        }
        resolve(response);
      });
    });
  });

  return Promise.all(availabilityProms);
};

export const fetchDayAvailability = ({
  spaceId,
  date,
  excludeBookingIds,
  startTimeIndex
}) => {
  const excludeBookingsQuery = Array.isArray(excludeBookingIds)
    ? excludeBookingIds
        .map((bkID, i) => {
          const queryExtension = `exclude_booking_ids=${bkID}`;
          return i === 0 ? `&${queryExtension}` : queryExtension;
        })
        .join('&')
    : '';

  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  const day = date.getDate();

  const startOrEnd = startTimeIndex === undefined ? 'start' : 'end';
  const timeIndexQuery =
    startOrEnd === 'end' ? `&time_index=${startTimeIndex}` : '';

  const query = `bookings/availability/space/${spaceId}/day/${startOrEnd}?year=${year}&month=${month}&day=${day}${excludeBookingsQuery}${timeIndexQuery}`;

  return new Promise((resolve, reject) => {
    Calendar.readAnonymous(query, (response) => {
      if (response.error || response.statusCode >= 400) {
        reject(response);
        return;
      }
      resolve(response[`${startOrEnd}_availability`] || []);
    });
  });
};
